<template>
        <div class="q-pt-xl auth-layout full-height">
          <router-view />
        </div>
</template>

<script>
export default {
  name: "AuthLayout",
  data() {
    return {
    };
  },
};
</script>
<style lang="scss">
.auth-layout {
  background: rgb(10,0,182);
  background: linear-gradient(150deg, rgba(10,0,182,1) 0%, rgba(68,68,147,1) 36%, rgba(8,184,219,1) 100%);
}
</style>
